export const SessionBlockType = {
  SESSION_EXERCISE: "SESSION_EXERCISE",
  COACH_NOTE: "COACH_NOTE",
  ATHLETE_NOTE: "ATHLETE_NOTE",
  MEDIAS: "MEDIAS",
} as const

export type SessionBlockType = (typeof SessionBlockType)[keyof typeof SessionBlockType]
